module.exports = {
  localeName: 'en-SG',
  momentFormat: 'DD/MM/YYYY'
};
